import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getAnalyticsPageName } from 'modules/meta/selectors';
import { getClickedOfferRate, getIsUserLandingDirectlyOnSrp, getIsUserSearch, getSearchDisplayName, isDatesDefault } from 'modules/search/selectors';
import { getLayout } from 'modules/search/selectors';
import { LayoutType } from 'modules/search/types';
import { getSearchBoxDestinationDisplayValue, getSearchBoxValues, getShowRoomsLabel } from 'modules/searchBox/selectors';
import { openSearchBox, setIsSearchBoxActive } from 'modules/searchBox/slice';
import { SearchBoxAncestor } from 'modules/searchBox/types';
import { toggle } from 'opticks';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { logTimeStart } from '@daedalus/core/src/_web/utils/logging/performanceTimer';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Page } from '@daedalus/core/src/analytics/types/Events';
import { roomsToConfigurationObject } from '@daedalus/core/src/room/business/roomConfiguration';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
import { SearchSummaryButton } from '@daedalus/shared/src/search/SearchSummaryButton';
interface PropsType {
  ancestor: SearchBoxAncestor;
  isCompact?: boolean;
  withSidePadding?: boolean;
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wumj66q",
  propsAsIs: false
});
export const SearchSummaryButtonWithStore = ({
  ancestor,
  isCompact = false,
  withSidePadding = true
}: PropsType) => {
  const dispatch = useDispatch();

  // Added as part of ab519a8e-date-confirmation-tooltip
  const isUserLandingDirectlyOnSRP = useSelector(getIsUserLandingDirectlyOnSrp);
  const page = useSelector(getAnalyticsPageName);
  const clickedOfferRate = useSelector(getClickedOfferRate);
  const isUserSearch = useSelector(getIsUserSearch);
  const isDefaultDates = useSelector(isDatesDefault);
  const layout = useSelector(getLayout);
  // END Added as part of ab519a8e-date-confirmation-tooltip

  const {
    rooms,
    checkIn,
    checkOut
  } = useSelector(getSearchBoxValues) || {};
  const searchDisplayName = useSelector(getSearchDisplayName);
  const searchBoxDestinationDisplayValue = useSelector(getSearchBoxDestinationDisplayValue);
  const destination = searchDisplayName || searchBoxDestinationDisplayValue;
  const showRoomsLabel = useSelector(getShowRoomsLabel);
  const {
    brandHasAlternativeSearchForm
  } = useBrand();
  const {
    numberOfAdults,
    numberOfChildren,
    numberOfRooms
  } = roomsToConfigurationObject(rooms);
  const checkOutDate = dateStringToMiddayDate(checkOut);
  const checkInDate = dateStringToMiddayDate(checkIn);
  const handleClick = useCallback(() => {
    logTimeStart('SearchBoxReady');
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SearchSummary,
      action: Action.Clicked
    }));
    dispatch(openSearchBox(ancestor));
    dispatch(setIsSearchBoxActive(true));
  }, [dispatch, ancestor]);
  return <Wrapper className={withSidePadding && '__padding'}>
      <SearchSummaryButton checkIn={checkInDate} checkOut={checkOutDate} destination={destination} numberOfGuests={numberOfAdults + numberOfChildren} numberOfRooms={numberOfRooms} onClick={handleClick} isCompact={isCompact} isRoomsLabelShown={showRoomsLabel} isRounded={!brandHasAlternativeSearchForm} isNeutralColor={brandHasAlternativeSearchForm} isUserLandingDirectlyOnSRP={isUserLandingDirectlyOnSRP && page === Page.Search && Number.isNaN(clickedOfferRate) && !isUserSearch && isDefaultDates && layout !== LayoutType.MAP && toggle('ab519a8e-date-confirmation-tooltip', false, true)} />
    </Wrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");